import { FC } from 'react';

import { Box } from '@mui/material';
import styles from 'pages/feedback/Feedback.module.css';
import EmailIcon from '@mui/icons-material/Email';

export const Feedback: FC = () => {

    return (
        <Box className={styles.contentBox}>
            <Box className={styles.columnText}>
                <p className={styles.title}>Для предложений относительно работоспособности и функционала ЛК</p>
                <p className={styles.infoText}>
                    <span className={styles.icon}><EmailIcon /></span>
                    <a href="mailto:dmsmobilehelp@ugsk.ru" className={styles.link}>dmsmobilehelp@ugsk.ru</a>
                </p>
            </Box>
        </Box>

    );
};

export default Feedback;
